// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingArtifact
 */
export interface TrainingArtifact {
    /**
     * Training artifact identifier
     * @type {number}
     * @memberof TrainingArtifact
     */
    id: number;
    /**
     * Training session ID to which the artifact belongs
     * @type {number}
     * @memberof TrainingArtifact
     */
    trainingSession: number;
    /**
     * Result of the captured step
     * @type {string}
     * @memberof TrainingArtifact
     */
    status: TrainingArtifactStatusEnum;
    /**
     * Failure context if the artifact status is fail
     * @type {string}
     * @memberof TrainingArtifact
     */
    errorInfo?: string;
    /**
     * Zero-based main step index for the recorded action
     * @type {number}
     * @memberof TrainingArtifact
     */
    stepIndex: number;
    /**
     * Step type, where i = interaction and a = assertion
     * @type {string}
     * @memberof TrainingArtifact
     */
    stepType: TrainingArtifactStepTypeEnum;
    /**
     * Zero-based counter for nested interactions inside the same step
     * @type {number}
     * @memberof TrainingArtifact
     */
    subStep?: number;
    /**
     * Human readable description for the sub-step
     * @type {string}
     * @memberof TrainingArtifact
     */
    subStepTxt?: string;
    /**
     * Full-size screenshot captured for the step
     * @type {string}
     * @memberof TrainingArtifact
     */
    imgFull?: string;
    /**
     * Thumbnail screenshot preview for the step
     * @type {string}
     * @memberof TrainingArtifact
     */
    imgThumb?: string;
    /**
     * Exact time when the automation performed the action
     * @type {Date}
     * @memberof TrainingArtifact
     */
    timestamp?: Date;
    /**
     * Browser URL or location when the artifact was recorded
     * @type {string}
     * @memberof TrainingArtifact
     */
    browserLocation?: string;
    /**
     * Serialized AI reasoning or auxiliary metadata captured for the artifact
     * @type {{ [key: string]: any; }}
     * @memberof TrainingArtifact
     */
    otherInfoJson?: { [key: string]: any; };
    /**
     * Timestamp when the artifact entry was created
     * @type {Date}
     * @memberof TrainingArtifact
     */
    createdAt?: Date;
}

export function TrainingArtifactFromJSON(json: any): TrainingArtifact {
    return {
        'id': json['id'],
        'trainingSession': json['training_session'],
        'status': json['status'],
        'errorInfo': !exists(json, 'error_info') ? undefined : json['error_info'],
        'stepIndex': json['step_index'],
        'stepType': json['step_type'],
        'subStep': !exists(json, 'sub_step') ? undefined : json['sub_step'],
        'subStepTxt': !exists(json, 'sub_step_txt') ? undefined : json['sub_step_txt'],
        'imgFull': !exists(json, 'img_full') ? undefined : json['img_full'],
        'imgThumb': !exists(json, 'img_thumb') ? undefined : json['img_thumb'],
        'timestamp': !exists(json, 'timestamp') ? undefined : new Date(json['timestamp']),
        'browserLocation': !exists(json, 'browser_location') ? undefined : json['browser_location'],
        'otherInfoJson': !exists(json, 'other_info_json') ? undefined : json['other_info_json'],
        'createdAt': !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
    };
}

export function TrainingArtifactToJSON(value?: TrainingArtifact): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'training_session': value.trainingSession,
        'status': value.status,
        'error_info': value.errorInfo,
        'step_index': value.stepIndex,
        'step_type': value.stepType,
        'sub_step': value.subStep,
        'sub_step_txt': value.subStepTxt,
        'img_full': value.imgFull,
        'img_thumb': value.imgThumb,
        'timestamp': value.timestamp === undefined ? undefined : value.timestamp.toISOString(),
        'browser_location': value.browserLocation,
        'other_info_json': value.otherInfoJson,
        'created_at': value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
    };
}

/**
* @export
* @enum {string}
*/
export enum TrainingArtifactStatusEnum {
    Pass = 'pass',
    Fail = 'fail'
}
/**
* @export
* @enum {string}
*/
export enum TrainingArtifactStepTypeEnum {
    I = 'i',
    A = 'a'
}


